import request from '@/utils/request';
import { stringify } from 'qs';

//我的试卷
export async function info(params: any): Promise<any> {
  let url = `/api/v1/pb/papers/${params.paper_id}`;

  if (params.hasOwnProperty('exam_id')) {
    url += `?exam_id=${params.exam_id}`;
  }
  return request(url);
}

//我的试卷
export async function questionApi(params: any): Promise<any> {
  let url = `/api/v1/pb/questions/${params.questionId}`;
  if (params.exam_id) {
    url = url + `?exam_id=${params.exam_id}`;
  }
  return request(url);
}

//收藏
export async function collectionsPostApi(params: any): Promise<any> {
  return request(`/api/v1/pb/collections`, {
    method: 'POST',
    data: {
      paper_id: params.paper_id,
      question_id: params.question_id,
      subject_id: params.subject_id,
    },
  });
}

//取消收藏
export async function collectionsDeleteApi(params: any): Promise<any> {
  return request(`/api/v1/pb/collections`, {
    method: 'DELETE',
    data: {
      paper_id: params.paper_id,
      question_id: params.question_id,
      subject_id: params.subject_id,
    },
  });
}

//上传试卷
export async function upAnswersApi(params: any): Promise<any> {
  return request(`/api/v1/pb/records`, {
    method: 'post',
    data: params,
  });
}
